import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { SearchParams } from "./-data/model";
import { Loading } from "@/layouts/loading";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(inventory)/branch/_layout/reports/sales-per-item/")({
  component: Component,
  validateSearch: SearchParams,
});
